export const audienceAnalysisConfig = {
  measuredResult: [
    {
      label: 'Households Available for Targeting',
      value: 'household_available',
      unit: 'none',
    },
    {
      label: 'Opportunities Generated',
      value: 'opps_',
      unit: 'none',
    },
    {
      label: 'Opportunities Won',
      value: 'won_opps',
      unit: 'none',
    },
    {
      label: 'Spend',
      value: 'spend_',
      unit: '$',
      subRows: [
        {
          label: 'Television*',
          value: 'tv_spend',
          unit: '$',
        },
        {
          label: 'Radio*',
          value: 'radio_spend',
          unit: '$',
        },
        {
          label: 'Outdoor*',
          value: 'outdoor_spend_',
          unit: '$',
        },
        {
          label: 'Magazines*',
          value: 'magazines_spend_',
          unit: '$',
        },
        {
          label: 'Newspaper*',
          value: 'newspaper_spend_',
          unit: '$',
        },
        {
          label: 'Local Website*',
          value: 'local_website_spend_',
          unit: '$',
        },
        {
          label: 'Broad Reach*',
          value: 'broad_reach_',
          unit: '$',
        },
        {
          label: 'Programmatic',
          value: 'programmatic_spend_',
          unit: '$',
        },
        {
          label: 'Facebook',
          value: 'facebook_spend_',
          unit: '$',
        },
        {
          label: 'Instagram',
          value: 'instagram_spend_',
          unit: '$',
        },
        {
          label: 'Pinterest',
          value: 'pinterest_spend_',
          unit: '$',
        },
        {
          label: 'Direct Mail',
          value: 'direct_mail_spend_',
          unit: '$',
        },
        {
          label: 'SEM Brand*',
          value: 'sem_brand_',
          unit: '$',
        },
        {
          label: 'Non Branded*',
          value: 'non_brand_spend_',
          unit: '$',
        },
        {
          label: 'Nurture*',
          value: 'nurture_spend_',
          unit: '$',
        },
        {
          label: 'Management Fees*',
          value: 'management_fees_',
          unit: '$',
        },
        {
          label: 'Others*',
          value: 'others',
          unit: '$',
        },
      ],
    },
    {
      label: 'Sales',
      value: 'sales_',
      unit: '$',
    },
  ],
  calculatedPerformanceIndicators: [
    {
      label: 'Cost per Opportunity',
      value: 'cpo_',
      unit: '$',
    },
    {
      label: 'Return on Marketing Investment',
      value: 'romi_',
      unit: '$',
    },
    {
      label: 'Average Job Size',
      value: 'avg_job_size_',
      unit: '$',
    },
    {
      label: 'Close Rate',
      value: 'close_rate_',
      unit: '%',
    },
    {
      label: 'Cancellation Rate',
      value: 'cancel_rate_',
      unit: '%',
    },
  ],
};
export const audienceAnalysisDownloadReportColumns = [
  {
    Header: ' ',
    accessor: 'propertyName',
    enableRowSpan: true,
  },
  {
    header: '',
    accessor: 'expand',
  },
  {
    Header: 'Quarter',
    accessor: 'channels',
  },
  {
    Header: 'Total',
    accessor: 'total',
  },
  {
    Header: 'Tier A',
    accessor: 'tierA',
  },
  {
    Header: 'Tier B',
    accessor: 'tierB',
  },
  {
    Header: 'Tier C',
    accessor: 'tierC',
  },
  {
    Header: 'Tier D',
    accessor: 'tierD',
  },
  {
    Header: 'Self-Identified',
    accessor: 'selfIdentified',
  },
  {
    Header: 'Comparison Period',
    accessor: 'comparePercent',
  },
];
